




































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { SfImage, SfLink, SfPagination } from '@storefront-ui/vue';
import HTMLContent from '~/components/HTMLContent.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

import { Article } from '../types';

export default defineComponent({
  name: 'ArticlesList',
  components: {
    SfImage,
    SfLink,
    SfPagination,
    HTMLContent,
    SkeletonLoader,
  },
  props: {
    articles: {
      type: Array as PropType<Article[]>,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
});
